module.exports = __webpack_public_path__ + "img/ltkswim-4x.a1778a5.jpg";